import { render, staticRenderFns } from "./SingleLayout.vue?vue&type=template&id=75cfe09e"
import script from "./SingleLayout.vue?vue&type=script&lang=js"
export * from "./SingleLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports